export function nodeImageUrl(node, assets2d) {
  const parts = [node.type, status(node)].filter(i => i != null)
  const assetName = parts.join("_")
  return assets2d[assetName] || assets2d.compute_on
}

export function nodeWithLightsImageUrl(node, assets2d) {
  const parts = [node.type, status(node), lightAnimation(node)].filter(i => i != null)
  const assetName = parts.join("_")
  return assets2d[assetName]
}

function status(node) {
  switch (node.status) {
    case "running":
      return "on"
    case "pending":
      return "alert"
    case "stopped":
      return "off"
    default:
      return "on"
  }
}

function lightAnimation(node) {
  if (node.lightAnimation !== "none") {
    return "with-lights"
  }
}
